<template>
  <div class="wire-transfer">
    <div class="title">支付订单</div>
    <div class="content">
      <div>
        应付平台服务费：<em>{{ commitment.totalAmount }}</em>
      </div>
      <div class="payDetail">
        <div >
          <p>电汇信息</p>
          <div v-if="commitment.bfeChannelPartnerAccountVo && (commitment.bfeChannelPartnerAccountVo.chargeProductType.includes('9600') || commitment.bfeChannelPartnerAccountVo.chargeProductType.includes('7000'))|| !commitment.bfeChannelPartnerAccountVo.chargeProductType">
          <p>
            <span>户名：</span>
            <span>{{ commitment.bfeChannelPartnerAccountVo.accountName }}</span>
          </p>
          <p>
            <span>账号：</span>
            <span>{{ commitment.bfeChannelPartnerAccountVo.accountNo }}</span>
          </p>
          <p>
            <span>开户行：</span>
            <span>{{ commitment.bfeChannelPartnerAccountVo.openingBank }}</span>
          </p>
          <p v-if="commitment.bfeChannelPartnerAccountVo.openingBankNo">
            <span>开户行行号：</span>
            <span>{{ commitment.bfeChannelPartnerAccountVo.openingBankNo }}</span>
          </p>
          </div>
        </div>
        <div>
          <el-form
            class="form"
            ref="form"
            :model="form"
            :rules="rules"
            label-width="100px"
          >
            <el-form-item label="电汇底单" prop="basicPayFile">
              <Upload
                uploadTitle="请上传电汇底单"
                @fileIdCb="uploadSuccess"
                :fileId="form.basicPayFile"
                :filetypes="['pdf', 'doc', 'docx', 'rar', 'zip', 'jpg', 'jpeg', 'png', 'bmp', 'gif']"
                :maxSize="fileMaxSize"
                accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
              >
                <template #explain>
                  <ul slot="tip" class="el-upload__tip">
                    <li>仅支持上传PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG格式的文件</li>
                  </ul>
                </template></Upload
              >
            </el-form-item>
            <el-form-item
           v-if="!(bankId === '29')"
              label="开户许可证"
              prop="basicFile"
            >
              <Upload
                uploadTitle="请上传开户许可证"
                @fileIdCb="uploadSuccessBasicFile"
                :fileId="form.basicFile"
                :filetypes="['pdf', 'doc', 'docx', 'rar', 'zip', 'jpg', 'jpeg', 'png', 'bmp', 'gif']"
                accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
              >
                <template #explain>
                  <ul slot="tip" class="el-upload__tip">
                    <li>仅支持上传PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG格式的文件</li>
                  </ul>
                </template></Upload
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="notice" v-if="commitment.bfeChannelPartnerAccountVo && commitment.bfeChannelPartnerAccountVo.isOrgPay ==='0' && commitment.bfeChannelPartnerAccountVo.chargeProductType.includes('9600')">
        <h3>特别提醒 （转账前必读）</h3>
        <p>
          1.保函费的支付必须为“公对公转账”。汇款时请备注保函费用，汇款后，需到平台订单详情页上传电汇底单及开户许可证，才算支付成功
        </p>
        <p>
          2.请及时付清款项，担保机构审核并确认收款后将立即出函
        </p>
        <p>3.为方便客户支付以及提升保函平台审核效率，平台的保函费用统一由招采进宝招采进宝(上海)信息技术有限公司代为收取，收取的保函费用最终属于您选择的担保公司，因担保费用是由招采进宝(上海)信息技术有限公司代收代付，故本保函订单发票由{{ commitment.channelPartnerName }}开具，特此说明!</p>
        <p>4.有任何疑问请联系担保机构{{ commitment.bfeChannelPartnerAccountVo.telNo }}（电话）</p>
      </div>
      <div class="notice" v-else-if="bankId === '29'">
        <h3>特别提醒 （转账前必读）</h3>
       <p>
        1.保函费的支付必须为<span style="font-weight:bold; color:red;">“公对公转账”。汇款时请备注项目名称+保函费</span>，汇款后，需到平台订单详情页上传电汇底单，才算支付成功。
        </p>
        <p>
          2.请尽快付清款项，平台管理员确认平台收款账户到账后，会及时安排出函
        </p>
        <p>3.为方便客户支付以及提升保函平台审核效率，平台的保函费用统一由招采进宝招采进宝(上海)信息技术有限公司代为收取，收取的保函费用最终属于您选择的担保公司，因担保费用是由招采进宝(上海)信息技术有限公司代收代付，故本保函订单发票由{{ commitment.channelPartnerName }}开具，特此说明!</p>
         <p>4.有任何疑问请联系客服4006166620-3</p>
      </div>
      <div class="notice" v-else>
        <h3>特别提醒 （转账前必读）</h3>
        <p>
          1.保函费的支付必须为“公对公转账”。汇款时请备注保函费用，汇款后，需到平台订单详情页上传电汇底单及开户许可证，才算支付成功
        </p>
        <p>
          2.请尽快付清款项，平台管理员确认平台收款账户到账后，会及时安排出函
        </p>
        <p>3.为方便客户支付以及提升保函平台审核效率，平台的保函费用统一由招采进宝招采进宝(上海)信息技术有限公司代为收取，收取的保函费用最终属于您选择的担保公司，因担保费用是由招采进宝(上海)信息技术有限公司代收代付，故本保函订单发票由{{ commitment.channelPartnerName }}开具，特此说明!</p>
        <p>4.有任何疑问请联系客服4006166620-3</p>
        <p v-if="this.apiId === 'cqsw' || this.apiId === 'cqsw_v6'" class="font-red">5.本平台仅代收保函费用，保函发票将由出函机构陕西诚信达工程履约担保有限公司出具，如需证明文件请联系平台客服4006166620转3</p>
      </div>
    </div>
  </div>
</template>

<script>
import { commitmentScendCallback } from '@/api/comm'
import { telegraphicSubmit,queryOrderDetail } from '@/api/order'
import uploadE from '@/common/upload/uoload.vue'

const getCommitmentScendCallback = ({ id }) => {
  return commitmentScendCallback(id).then((res) => {
    if (res.data) {
      return res.data
    } else {
      return false
    }
  })
}

export default {
  name: 'WireTransfer',
  components: {
    Upload: uploadE,
  },
  data() {
    const fileIdpass = (rule, value, callback) => {
      if (this.form.basicPayFile) {
        callback()
      } else {
        return callback(new Error('请上传电汇底单'))
      }
    }

    const fileBasicFiles = (rule, value, callback) => {
      if (this.form.basicFile) {
        callback()
      } else {
        return callback(new Error('请开户许可证'))
      }
    }

    return {
      commitment: {},
      form: {},
      rules: {
        basicPayFile: { required: true, validator: fileIdpass },
        basicFile: { required: true, validator: fileBasicFiles },
      },
      bankId: '',
      fileMaxSize: 1073741824, // 上传文件大小限制
      apiId:''
    }
  },
  beforeMount() {
      queryOrderDetail(this.$route.query.order).then((res) => {
    if (res.data) {
      this.bankId = res.data.applicationChannelBankId
      this.fileMaxSize = res.data.applicationChannelBankId === '29'?(1024*1024*3):1073741824
      this.apiId = res.data.apiId
    }
  })
     getCommitmentScendCallback({
      id: this.$route.query.order,
    }).then((res) => {
      this.commitment = res
    })
   
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          telegraphicSubmit(
            Object.assign({ orderId: this.$route.query.order }, this.form)
          ).then((v) => {
            if (v.code === 200) {
              this.$router.replace({
                path: '/orderDetail',
                query: {
                  order: this.$route.query.order,
                },
              })
            }
          })
        } else {
          return false
        }
      })
    },
    uploadSuccess(res) {
      this.form.basicPayFile = res.url
      this.$refs.form.validateField('basicPayFile')
    },
    uploadSuccessBasicFile(res) {
      this.form.basicFile = res.url
      this.$refs.form.validateField('basicFile')
    },
  },
}
</script>

<style lang="scss" scoped>
.font-red {
        color: red;
      }
.wire-transfer {
  width: 1000px;
  background-color: white;
  padding: 20px;
  margin: 0 auto;
  border-radius: 4px;
  .title {
    font-size: 24px;
    font-weight: normal;
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
  }
  .content {
    font-size: 16px;
    width: 676px;
    margin: 46px auto;
    em {
      color: #f52f3e;
      font-style: normal;
      font-size: 28px;
    }
    .payDetail {
      display: flex;
      justify-content: space-between;
      background-color: #fff4f4;
      padding: 20px 30px;
      margin-top: 20px;
      line-height: 2;
      overflow: hidden;
      .form {
        width: 330px;
        overflow: hidden;
      }
    }
    .notice {
      margin-top: 30px;
      line-height: 2;
      h3 {
        margin: 0 0 10px 0;
        font-size: 16px;
        font-weight: normal;
      }
      p {
        font-size: 14px;
      }
    }
  }
}
</style>
